import { get, post, put } from "../lib/axios-client";
import * as url from "../lib/url_helper";
import { parseApiError } from "../utils/api_error";

export const postJwtLogin = async (data) => {
  try {
    const response = await post(url.SIGN_IN, data);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const postJwtRegister = async (data) => {
  try {
    const response = await post(url.SIGN_UP, data);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getConfirmUser = async ({ userId, token }) => {
  try {
    const response = await get(url.CONFIRM_EMAIL, {
      params: {
        userId,
        token,
      },
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await get(url.CURRENT_USER);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const updateCurrentUserApi = async (data) => {
  try {
    const response = await put(url.CURRENT_USER, data);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getCompanyProfile = async () => {
  try {
    const response = await get(url.COMPANY_PROFILE);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getTenants = async () => {
  try {
    const response = await get(url.TENANTS, {
      params: {
        pageIndex: 0,
        pageSize: 100,
      },
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};
